const getWindGustInfo = (weatherItem) => {
  const detailedForecastExtract = weatherItem.detailedForecast;
  const reg = /gusts as high as \d+ mph/g;
  return detailedForecastExtract.match(reg) || '';
};

export { getWindGustInfo };
